
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import Container from '@/components/form/container/Container.vue'
import { useI18n } from 'vue-i18n'
import ZHTransactionRecordHistoryTab from '@/views/pay/tabs/ZHTransactionRecordHistoryTab.vue'
import XYTransactionRecordHistoryTab from '@/views/pay/tabs/XYTransactionRecordHistoryTab.vue'
import JHTransactionRecordHistoryTab from '@/views/pay/tabs/JHTransactionRecordHistoryTab.vue'
import { getBankInfoForReceiptList } from '@/apis/main-data/company'

export default defineComponent({
  name: 'PaymentSlipStatement',
  components: {
    Container,
    ZHTransactionRecordHistoryTab,
    XYTransactionRecordHistoryTab,
    JHTransactionRecordHistoryTab
  },
  setup() {
    const { t } = useI18n()
    const dataMap = reactive({
      activeCode: '',
      bankList: Array<any>(),
      listLoading: true
    })
    const getBankList = async() => {
      dataMap.listLoading = true
      const data = await getBankInfoForReceiptList()
      if (data && data.data && data.data.length > 0) {
        data.data.forEach(item => {
          if (item.name.includes('中国银行') || item.name.includes('兴业银行') || item.name.includes('建设银行')) {
            dataMap.bankList.push({
              name: item.name,
              code: item.code,
              account: item.account
            })
          }
        })
        dataMap.activeCode = dataMap.bankList[0].code
      } else {
        dataMap.bankList = []
      }
      setTimeout(() => {
        dataMap.listLoading = false
      }, 0.5 * 1000)
    }
    onMounted(() => {
      getBankList()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
